import React from "react";

const ProductLoader = () => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
      {[...Array(5)].map((_, index) => (
        <div
          key={index}
          className="bg-white rounded-lg shadow-sm p-4 h-80 animate-pulse border border-gray-100"
        >
          <div className="w-full h-48 bg-gray-200 mb-4 rounded-md"></div>
          <div className="h-4 bg-gray-200 rounded-md mb-2 w-3/4"></div>
          <div className="h-4 bg-gray-200 rounded-md w-1/2 mb-2"></div>
          <div className="h-6 bg-gray-200 rounded-md w-1/3 mt-4"></div>
        </div>
      ))}
    </div>
  );
};

export default ProductLoader;
